export function isPromiseLike<TResult>(val: any): val is PromiseLike<TResult> {
    return val && typeof val.then === 'function';
}
